<template>
  <div class="common-step">
    <!-- 主题 -->
    <template v-if="question?.[type]?.length > 0">
      <template v-for="(item,index) of question?.[type]">
        <!-- 只渲染有内容的部分 -->
        <BasicStep
          :key="`basic-${index}`"
          :itemData="item"
          :index="index"
          :showTitle="!hasSmallQustions"
          :type="type"
          v-if="hasTypeData(item)"
        ></BasicStep>
      </template>
    </template>
    <!-- 小题 -->
    <template v-if="hasSmallQustions && questionsHasData(question, type)">
      <template v-for="(item,index) of question?.questions">
        <!-- 只渲染有内容的小题 -->
        <div
          class="question-content-box"
          :key="`child-${index}`"
          v-if="questionsHasData(item,type)"
        >
          <div class="question-number">第{{ index + 1 }}小题</div>
          <commonStep
            :question="item"
            :type="type"
          ></commonStep>
        </div>
      </template>
    </template>
  </div>
</template>
<script>
import BasicStep from "./components/basicStep.vue";
export default {
  components: { BasicStep },
  props: {
    question: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      hasSmallQustions: true,
    };
  },
  methods: {
    // 判断下级层级小题内type是否有数据,任意下级层级type有数据，也会返回true
    questionsHasData(question, type) {
      const questions = question?.questions || [];
      if (questions?.length > 0) {
        return questions.some((item) => this.questionsHasData(item, type));
      } else {
        const data = question?.[type];
        return data.some((item) => this.hasTypeData(item));
      }
    },
    // 判断item是否有数据
    hasTypeData(item) {
      const hasTitle =
        item?.title && item?.title !== "" && item?.title !== undefined;
      const hasContent =
        item?.content &&
        item?.content !== "" &&
        item?.content !== "<p><br></p>" &&
        item?.content !== undefined;
      return hasTitle || hasContent;
    },
  },
  watch: {
    question: {
      handler(val) {
        if (val) {
          if (val?.questions?.length > 0) {
            this.hasSmallQustions = true;
          } else {
            this.hasSmallQustions = false;
          }
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang=less scoped>
.question-content-box {
  margin-bottom: 8px;
  &:last-child {
    margin-bottom: 0;
  }
  .question-number {
    font-weight: bold;
    font-size: 14px;
    color: #000000;
    margin-bottom: 8px;
  }
}
</style>